export default {
      id: "flex-flexWrap-nowrap-usage",
      viewBox: "0 0 40 40",
      url: "assets/" + "sprite.svg#flex-flexWrap-nowrap-usage",
      toString: function () {
        return this.url;
      }
    }